import css from 'styled-jsx/css';

const styles = css.global`#cdc-protegido-banner.stacked-banner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  position: relative;
  z-index: 9;
}

#cdc-protegido-banner .bg-image-wrapper {
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}

#cdc-protegido-banner .bg-image-wrapper picture {
  display: flex;
  width: 100%;
  height: 100%;
}

#cdc-protegido-banner .bg-image-wrapper picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#cdc-protegido-banner .fade-banner {
  opacity: 0.25;
  background: var(--Red-Red-Boston-01, #C00);
  position: absolute;
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}
#cdc-protegido-banner .fade-banner-gradiente {
  background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
}

#cdc-protegido-banner .santander-symbol {
  background-image: url(assets/c2c/banners/santander-symbol.svg);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
  left: -90px;
  background-repeat: no-repeat;
  background-size: contain;
}

#cdc-protegido-banner .text-box-position {
  margin-top: -200px;
  position: relative;
}

#cdc-protegido-banner .text-box {
  background: #990000;
  width: 100%;
  max-width: 849px;
  padding: 24px 16px 40px 16px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}

#cdc-protegido-banner .text-box .main-text {
  font-family: 'SantanderHeadline';
  font-size: 40px;
  font-weight: 400;
  line-height: 60px;
  text-align: left;
  color: #fff;
}

#cdc-protegido-banner .text-box .alt-text {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  color: #fff;
  max-width: 600px;
}

#cdc-protegido-banner .text-box .btn-simulate {
  box-sizing: border-box;
  height: 48px;
  width: 200px;
}


@media (min-width: 992px) {
  #cdc-protegido-banner.stacked-banner {
    padding-bottom: 8px!important;
  }
  
  
  #cdc-protegido-banner .text-box {
    padding: 24px 16px 49px 47px;
    gap: 0;
  }

  #cdc-protegido-banner .text-box .alt-text {
    height: 112px;
  }

  #cdc-protegido-banner .santander-symbol { 
    left: 0;
    width: 537px;
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }

  #cdc-protegido-banner .bg-image-wrapper,
  #cdc-protegido-banner .fade-banner,
  #cdc-protegido-banner .fade-banner-gradiente {
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }
}
@media (min-width: 1200px) {
  #cdc-protegido-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  } 
}

@media (min-width: 1600px) {
  #cdc-protegido-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  } 
}

@media (min-width: 1900px) {
  #cdc-protegido-banner .bg-image-wrapper picture img {
    object-position: 0 39%;
  } 
}`;

export default styles;